import cn from 'classnames';
import type { ReactNode } from 'react';
import type React from 'react';
import * as st from './styles.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  className?: string;
  padding20?: boolean;
}

export const Card: React.FC<Props> = ({ children, padding20, className, ...props }) => {
  return (
    <div className={cn(st.card, padding20 && st.padding20, className)} {...props}>
      {children}
    </div>
  );
};
